import React from 'react';
import {
  useGetCreditCardsQuery,
} from 'app/features/account/api/accountApi';

import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CreditCard from './CreditCard';
import AddIcon from '@mui/icons-material/Add';
import NoCards from './NoCards';

const CustomStyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    padding: theme.spacing(2.5, 3), // top-bottom, left-right
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3.5, 4), // top-bottom, left-right
  },
  pb: {
    xs: theme.spacing(10), // bottom padding for xs
    sm: theme.spacing(10), // bottom padding for sm
  },
}));

const CreditCardsContainer = () => {
  const { data: creditCards, isLoading } = useGetCreditCardsQuery();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (creditCards?.data.length === 0) {
    return <NoCards onAddCard={() => {}} />;
  }

  return (
    <CustomStyledBox>
      <Typography variant="h3" mb={3}>Payment Methods</Typography>
      { creditCards?.data.map((card) => (
        <CreditCard key={card.id} card={card} />
      ))}

      <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }} marginTop={3}>
        <a
          href="#"
          className="bluelink"
          tabIndex="0"
          onClick={() => {}}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <AddIcon htmlColor="#06c" />
          Add a Card
        </a>

        <Button
          variant="contained"
          color="primary"
          onClick={() => {}}
          sx={{ marginTop: 2 }}
        >
          Add Money
        </Button>
      </Box>
    </CustomStyledBox>
  );
};

export default CreditCardsContainer;
